import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const GestionPreocupante = () => {
    const [preocupantes, setPreocupantes] = useState([]);
    const [visible, setVisible] = useState(false);
    const [newPreocupante, setNewPreocupante] = useState({ id: null, nombre: '', descripcion: '', puntos: 0, id_usuario: null });
    const [editing, setEditing] = useState(false);
    
    useEffect(() => {
        cargarPreocupantes();
    }, []);

    const toast = useRef(null);

    const cargarPreocupantes = async () => {
        try {
            const response = await fetch('/api/merito/sancion/findall', {
                method: 'GET',
                headers: {
                    'Authorization': 'Basic ' + btoa('admin:querty')
                },
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                setPreocupantes(data);
            } else {
                console.error('Error al cargar preocupantes:', response.statusText);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    const agregarPreocupante = async () => {
        try {
            const response = await fetch('/api/merito/sancion/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newPreocupante),
                credentials: 'include'
            });

            if (response.ok) {
                cargarPreocupantes();
                setVisible(false);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Preocupante agregado correctamente' });
            } else {
                console.error('Error al agregar preocupante:', response.statusText);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    const actualizarPreocupante = async () => {
        try {
            const response = await fetch(`/api/merito/sancion/updatebyid/${newPreocupante.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newPreocupante),
                credentials: 'include'
            });

            if (response.ok) {
                cargarPreocupantes();
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Preocupante actualizado correctamente' });
            } else {
                console.error('Error al actualizar preocupante:', response.statusText);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    // Función para mostrar la confirmación antes de eliminar con mejor formato
    const confirmarEliminacion = (preocupante) => {
        confirmDialog({
            message: (
                <>
                    <p style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        ¿Está seguro de que desea eliminar el preocupante <span style={{ color: '#d9534f' }}>{preocupante.nombre}</span>?
                    </p>
                    <p>Esta acción no se puede deshacer.</p>
                </>
            ),
            header: 'Confirmar Eliminación',
            icon: 'pi pi-trash', // Icono más representativo de la eliminación
            acceptClassName: 'p-button-danger', // Clase para el botón de aceptar
            acceptLabel: 'Sí, eliminar',
            rejectLabel: 'No, cancelar',
            accept: () => eliminarPreocupante(preocupante.id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelado', detail: 'Eliminación cancelada' });
            }
        });
    };

    // Función para eliminar el preocupante
    const eliminarPreocupante = async (id) => {
        try {
            const response = await fetch(`/api/merito/sancion/deletebyid/${id}`, {
                method: 'DELETE',
                credentials: 'include'
            });

            if (response.ok) {
                cargarPreocupantes();
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Preocupante eliminado correctamente' });
            } else {
                console.error('Error al eliminar preocupante:', response.statusText);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    const handleAgregarPreocupante = () => {
        const username = localStorage.getItem('username'); // Obtener el username del localStorage
        setNewPreocupante({ id: null, nombre: '', descripcion: '', puntos: 0, id_usuario: username });
        setVisible(true);
    };

    const handleInputChange = (e, key) => {
        const value = e.target.value;
        setNewPreocupante(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const editarPreocupante = (preocupante) => {
        setNewPreocupante({
            id: preocupante.id,
            nombre: preocupante.nombre,
            descripcion: preocupante.descripcion,
            puntos: preocupante.puntos,
            id_usuario: preocupante.id_usuario
        });
        setVisible(true);
        setEditing(true);
    };

    const handleAgregarEditar = () => {
        if (editing) {
            // Cerrar el diálogo antes de actualizar para evitar la aparición del formulario de agregar
            setVisible(false);  // Cerrar el diálogo
            actualizarPreocupante().then(() => {
                setEditing(false);  // Desactivar el estado de edición solo después de cerrar el diálogo y actualizar
            });
        } else {
            agregarPreocupante();
        }
    };

    const renderToast = () => (
        <Toast ref={toast} />
    );

    return (
        <div className="p-grid p-fluid">
            {renderToast()}
            <ConfirmDialog /> {/* Añadir el componente ConfirmDialog aquí */}
            <div className="p-col-12">
                <Dialog visible={visible} style={{ width: '450px' }} header={editing ? "Editar Preocupante" : "Agregar Preocupante"} onHide={() => setVisible(false)} modal>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12">
                            <label htmlFor="nombre">Nombre:</label>
                            <InputText id="nombre" value={newPreocupante.nombre} onChange={(e) => handleInputChange(e, 'nombre')} />
                        </div>
                        <div className="p-col-12">
                            <label htmlFor="descripcion">Descripción:</label>
                            <InputText id="descripcion" value={newPreocupante.descripcion} onChange={(e) => handleInputChange(e, 'descripcion')} />
                        </div>
                        <div className="p-col-12">
                            <label htmlFor="puntos">Puntos:</label>
                            <InputNumber id="puntos" value={newPreocupante.puntos} onValueChange={(e) => handleInputChange(e, 'puntos')} />
                        </div>
                        <div className="p-col-12 p-d-flex p-jc-end">
                            <Button label="Cancelar" className="p-button-text" onClick={() => setVisible(false)} />
                            <Button label={editing ? 'Guardar' : 'Agregar'} className="p-button-raised" onClick={handleAgregarEditar} autoFocus />
                        </div>
                    </div>
                </Dialog>
            </div>
            <div className="p-col-12 p-mb-2">
                <Button label="Agregar Preocupante" className="p-button-raised p-button-success" onClick={handleAgregarPreocupante} />
            </div>
            <div className="p-col-12 p-grid-view">
                {preocupantes.map((preocupante, index) => (
                    <div key={index} className="product-item">
                        <div className="product-detail">
                            <div className="product-name">Nombre: {preocupante.nombre}</div>
                            <div className="product-description">Descripción: {preocupante.descripcion}</div>
                            <div className="product-puntos">Puntos: {preocupante.puntos}</div>
                        </div>
                        <div className="product-buttons">
                            <Button label="Editar" className="p-button-raised p-button-success" onClick={() => editarPreocupante(preocupante)} />
                            <Button label="Eliminar" className="p-button-raised p-button-danger" onClick={() => confirmarEliminacion(preocupante)} /> {/* Usar confirmarEliminacion */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GestionPreocupante;
